<template>
  <div
    class="info-icon"
    @mouseenter="setIsHovering(true)"
    @mouseleave="setIsHovering(false)"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="info-icon__svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle class="info-icon__background" cx="12" cy="12" r="11" />
      <path
        class="info-icon__i"
        d="M13.304 17.301c-.386.466-.87.699-1.449.699-.58 0-1.037-.149-1.372-.447-.322-.297-.483-.686-.483-1.165 0-.168.103-.873.31-2.116l.637-3.476h-.812l.039-.35h.83c.954 0 1.656-.038 2.107-.116l.27-.058-1.333 7.34c.387-.04.709-.22.966-.544l.29.233Zm-1.7-8.893a1.351 1.351 0 0 1-.406-.99c0-.389.135-.719.406-.99.27-.286.599-.428.985-.428.387 0 .715.142.986.427.283.272.425.602.425.99 0 .389-.142.719-.425.99-.27.273-.6.409-.986.409s-.715-.136-.985-.408Z"
      />
    </svg>
    <AppTooltip
      :show="isHovering"
      class="info-icon__tooltip"
      position="bottom"
      :showArrow="true"
      ><slot></slot
    ></AppTooltip>
  </div>
</template>

<script setup lang="ts">
import AppTooltip from '@/app/components/AppTooltip.vue'
import { ref } from 'vue'

/**
 * An icon that displays a tooltip on hover.
 */

const isHovering = ref(false)

function setIsHovering(newState: boolean): void {
  isHovering.value = newState
}
</script>

<style lang="scss" scoped>
.info-icon {
  position: relative;
  height: fit-content;

  &__svg {
    display: block;
    aspect-ratio: 1;
  }

  &__background {
    fill: $c-border-7;
  }

  &__i {
    fill: $c-black-6;
  }

  &__tooltip {
    @media only screen and (max-width: $w-tablet-s) {
      display: none;
    }
  }

  :deep(a) {
    color: $c-blue-4;
    text-decoration: underline;
    @include hover {
      color: $c-blue-2;
    }
  }
}

.night-mode .info-icon {
  &__background {
    fill: $c-dark-5;
  }

  &__i {
    fill: $c-dark-4;
  }
}
</style>
